var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33333V0H0V15H16V3.33333H8ZM3.2 13.3333H1.6V11.6667H3.2V13.3333ZM3.2 10H1.6V8.33333H3.2V10ZM3.2 6.66667H1.6V5H3.2V6.66667ZM3.2 3.33333H1.6V1.66667H3.2V3.33333ZM6.4 13.3333H4.8V11.6667H6.4V13.3333ZM6.4 10H4.8V8.33333H6.4V10ZM6.4 6.66667H4.8V5H6.4V6.66667ZM6.4 3.33333H4.8V1.66667H6.4V3.33333ZM14.4 13.3333H8V11.6667H9.6V10H8V8.33333H9.6V6.66667H8V5H14.4V13.3333ZM12.8 6.66667H11.2V8.33333H12.8V6.66667ZM12.8 10H11.2V11.6667H12.8V10Z",
    fill: "#656A6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectors);
export default __webpack_public_path__ + "static/media/icon_sectors.64b917a376ff6aeca57cd73d3dd025f1.svg";
export { ForwardRef as ReactComponent };